module.exports = __webpack_public_path__ + "img/fm-Path 4 Copy 2@3x.9e331dff.png";